import Vue from 'vue'
import VueRouter from 'vue-router'
import indexRouter from '@/router/index.js'
import NotFoundRouter from '@/router/notfound.js'

Vue.use(VueRouter)

//下面添加路由[NotFoundRouter,....]
const routes = [{
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "Index" */ '@/views/Auth/Login.vue')
  }, 
  {
    path: '/',
    meta: {requiresAuth: true},
    redirect: '/dashboard',
  },
  {
    path: '/monitor',
    name: '大屏',
    component: () => import(/* webpackChunkName: "Index" */ '@/views/Data/BigScreen.vue')
  },{
    path: '/',
    meta: {requiresAuth: true},
    component: () => import(/* webpackChunkName: "Index" */ '@/components/core/View.vue'),
    children: [{
        path: '/dashboard',
        name: '仪表盘',
        meta: {requiresAuth: true},
        component: () => import(/* webpackChunkName: "Index" */ '@/views/Dashboard/Index.vue')
      },
      //用户管理
      {
        path: '/user/bloc',
        name: '集团管理',
        meta: {requiresAuth: true},
        component: () => import(/* webpackChunkName: "Index" */ '@/views/Rbac/UserBloc.vue')
      },{
        path: '/user/site',
        name: '场所管理',
        meta: {requiresAuth: true},
        component: () => import(/* webpackChunkName: "Index" */ '@/views/Rbac/UserSite.vue')
      },{
        path: '/user/user',
        name: '用户管理',
        meta: {requiresAuth: true},
        component: () => import(/* webpackChunkName: "Index" */ '@/views/Rbac/UserUser.vue')
      },{
        path: '/user/role',
        name: '角色管理',
        meta: {requiresAuth: true},
        component: () => import(/* webpackChunkName: "Index" */ '@/views/Rbac/UserRole.vue')
      },{
        path: '/user/shipment',
        name: '发货管理',
        meta: {requiresAuth: true},
        component: () => import(/* webpackChunkName: "Index" */ '@/views/Rbac/UserShipment.vue')
      },
    //网关管理
      {
        path: '/gateway/waiting_device',
        name: '待绑定设备列表',
        meta: {requiresAuth: true},
        component: () => import(/* webpackChunkName: "Index" */ '@/views/Gateway/WaitingDevice.vue')
      },{
        path: '/gateway/devices',
        name: '设备列表',
        meta: {requiresAuth: true},
        component: () => import(/* webpackChunkName: "Index" */ '@/views/Gateway/Devices.vue')
      },{
        path: '/gateway/devices_list',
        name: '设备详情',
        meta: {requiresAuth: true},
        component: () => import(/* webpackChunkName: "Index" */ '@/views/Gateway/DeviceList.vue')
      },{
        path: '/gateway/remote_order',
        name: '远程指令',
        meta: {requiresAuth: true},
        component: () => import(/* webpackChunkName: "Index" */ '@/views/Gateway/RemoteOrder.vue')
      },{
        path: '/gateway/instructions_info',
        name: '指令详情',
        meta: {requiresAuth: true},
        component: () => import(/* webpackChunkName: "Index" */ '@/views/Gateway/Instructions.vue')
      },{
        path: '/gateway/instructions_add',
        name: '添加指令',
        meta: {requiresAuth: true},
        component: () => import(/* webpackChunkName: "Index" */ '@/views/Gateway/InstructionsAdd.vue')
      },{
        path:'/gateway/email',
        name:'邮箱管理',
        meta: {requiresAuth: true},
        component: () => import(/* webpackChunkName: "Index" */ '@/views/Gateway/Email.vue')
      },{
        path:'/gateway/alert',
        name:'告警管理',
        meta: {requiresAuth: true},
        component: () => import(/* webpackChunkName: "Index" */ '@/views/Gateway/Alert.vue')
      },{
        path:'/gateway/alert_record',
        name:'告警记录',
        meta: {requiresAuth: true},
        component: () => import(/* webpackChunkName: "Index" */ '@/views/Gateway/AlertRecord.vue')
      },
      // 设备管理
      {
        path: '/device/ap',
        name: 'Ap管理',
        meta: {requiresAuth: true},
        component: () => import(/* webpackChunkName: "Index" */ '@/views/Device/Ap.vue')
      },{
        path: '/device/device',
        name: '终端详情',
        meta: {requiresAuth: true},
        component: () => import(/* webpackChunkName: "Index" */ '@/views/Device/Device.vue')
      },{
        path: '/device/device_install',
        name: '安装信息',
        meta: {requiresAuth: true},
        component: () => import(/* webpackChunkName: "Index" */ '@/views/Device/DeviceInstall.vue')
      },{
        path: '/device/switch_status',
        name: '交换机详情',
        meta: {requiresAuth: true},
        component: () => import(/* webpackChunkName: "Index" */ '@/views/Device/SwitchStatus.vue')
      },{
        path: '/device/ap_info',
        name: 'AP详情',
        meta: {requiresAuth: true},
        component: () => import(/* webpackChunkName: "Index" */ '@/views/Device/ApInfo.vue')
      },
      //portal管理
      {
        path: '/portal/ac',
        name: '认证域',
        meta: {requiresAuth: true},
        component: () => import(/* webpackChunkName: "Index" */ '@/views/Portal/Ac.vue')
      },{
        path: '/portal/scheduler',
        name: '模板策略组',
        meta: {requiresAuth: true},
        component: () => import(/* webpackChunkName: "Index" */ '@/views/Portal/Scheduler.vue')
      },{
        path: '/portal/udemo',
        name: '用户模板',
        meta: {requiresAuth: true},
        component: () => import(/* webpackChunkName: "Index" */ '@/views/Portal/Udemo.vue')
      },{
        path: '/portal/sdemo',
        name: '系统模板',
        meta: {requiresAuth: true},
        component: () => import(/* webpackChunkName: "Index" */ '@/views/Portal/Sdemo.vue')
      },{
        path: '/portal/templatetype',
        name: '模板类型',
        meta: {requiresAuth: true},
        component: () => import(/* webpackChunkName: "Index" */ '@/views/Portal/TemplateType.vue')
      },
      //aaa管理
      {
        path: '/AAA/server_management',
        name: '服务端管理',
        meta: {requiresAuth: true},
        component: () => import(/* webpackChunkName: "Index" */ '@/views/Aaa/Server.vue')
      },{
        path: '/AAA/client_management',
        name: '客户端管理',
        meta: {requiresAuth: true},
        component: () => import(/* webpackChunkName: "Index" */ '@/views/Aaa/Client.vue')
      },{
        path: '/AAA/auth_management',
        name: '认证库管理',
        meta: {requiresAuth: true},
        component: () => import(/* webpackChunkName: "Index" */ '@/views/Aaa/Auth.vue')
      },{
        path:'/AAA/ldap_management',
        name:'Ldap管理',
        meta:{requiresAuth: true},
        component: () => import(/* webpackChunkName: "Index" */ '@/views/Aaa/Ldap.vue')
      },
      //网安管理
      {
        path: '/net_safety/device',
        name: '网安设备列表',
        meta: {requiresAuth: true},
        component: () => import(/* webpackChunkName: "Index" */ '@/views/NetSafety/Device.vue')
      },
      {
        path: '/net_safety/device_list',
        name: '网安设备详细列表',
        meta: {requiresAuth: true},
        component: () => import(/* webpackChunkName: "Index" */ '@/views/NetSafety/DeviceList.vue')
      },
      //短信管理
      {
        path: '/sms/api_management',
        name: '接口管理',
        meta: {requiresAuth: true},
        component: () => import(/* webpackChunkName: "Index" */ '@/views/SMS/ApiManagement.vue')
      },{
        path: '/sms/gateway_management',
        name: '网关管理',
        meta: {requiresAuth: true},
        component: () => import(/* webpackChunkName: "Index" */ '@/views/SMS/GatewayManagement.vue')
      },{
        path: '/sms/sending_record',
        name: '短信发送记录',
        meta: {requiresAuth: true},
        component: () => import(/* webpackChunkName: "Index" */ '@/views/SMS/SendingRecord.vue')
      },
      //数据管理
      {
        path: '/data/auth_record',
        name: '历史记录',
        meta: {requiresAuth: true},
        component: () => import(/* webpackChunkName: "Index" */ '@/views/Data/PortalMacAuth.vue')
      },{
        path: '/data/auth_online',
        name: '在线记录',
        meta: {requiresAuth: true},
        component: () => import(/* webpackChunkName: "Index" */ '@/views/Data/AuthOnline.vue')
      },{
        path: '/data/bindwidth_record',
        name: '带宽记录',
        meta: {requiresAuth: true},
        component: () => import(/* webpackChunkName: "Index" */ '@/views/Data/BindwidthRecord.vue')
      },{
        path: '/data/app_identification',
        name: '应用识别',
        meta: {requiresAuth: true},
        component: () => import(/* webpackChunkName: "Index" */ '@/views/Data/AppIdentification.vue')
      },{
        path: '/data/auth_record/:id',
        name: '用户画像',
        meta: {requiresAuth: true},
        component: () => import(/* webpackChunkName: "Index" */ '@/views/Data/Personas.vue')
      },{
        path: '/data/user_flow',
        name: '用户流量',
        meta: {requiresAuth: true},
        component: () => import(/* webpackChunkName: "Index" */ '@/views/Data/UserFlow.vue')
      },
      //系统管理
      {
        path: '/system/syslog',
        name: '系统日志',
        meta: {requiresAuth: true},
        component: () => import(/* webpackChunkName: "Index" */ '@/views/System/Syslog.vue')
      },{
        path: '/system/permission',
        name: '权限列表',
        meta: {requiresAuth: true},
        component: () => import(/* webpackChunkName: "Index" */ '@/views/System/Permission.vue')
      },{
        path: '/system/place_management',
        name: '地区管理',
        meta: {requiresAuth: true},
        component: () => import(/* webpackChunkName: "Index" */ '@/views/System/PlaceManagement.vue')
      },{
        path: '/system/config',
        name: '系统配置',
        meta: {requiresAuth: true},
        component: () => import(/* webpackChunkName: "Index" */ '@/views/System/Config.vue')
      }
    ],
  },
  NotFoundRouter]

const router = new VueRouter({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes
})

router.beforeEach((to, from, next) => {
    to.matched.some(r => {
        // 模块需要认证后使用
        if (r.meta.requiresAuth) {
            let authUser = window.sessionStorage.getItem('authUser')
            let userType = window.sessionStorage.getItem('type')

            // 未认证，或认证数据有问题，则跳转到login
            if (!authUser || !userType) {
                next({ name: 'Login' })
                return
            }

            // 已认证，判断模块访问类型，若admin则只允许admin访问，若user则只允许user访问，其他不限制
            // {
            //     if (r.meta.accessType == 'admin' && userType != 'admin') {
            //         next({ name: 'login' })
            //         return
            //     }

            //     if (r.meta.accessType == 'user' && userType != 'user') {
            //         next({ name: 'login' })
            //         return
            //     }
            // }
        }
    })
    next()
})

export default router
